import {
  resideoProProfileLink,
  resideoProMybusinessCompanyLink,
} from 'config/externalLinks';

export interface ProfileMenuItem {
  name?: string;
  linkTextKey?: string;
  linkPath?: string;
  isExternalLink?: boolean;
}

const profileMenuItems = (viewerHasPermissions: boolean): ProfileMenuItem[] => {
  const retval: ProfileMenuItem[] = [
    {
      name: 'profile',
      linkTextKey: 'header.profile',
      linkPath: resideoProProfileLink,
      isExternalLink: true,
    },
    {
      ...(viewerHasPermissions
        ? {
            name: 'company',
            linkTextKey: 'header.company',
            linkPath: resideoProMybusinessCompanyLink,
            isExternalLink: true,
          }
        : undefined),
    },
    {
      name: 'signout',
      linkTextKey: 'header.signout',
      linkPath: '/sign-out',
      isExternalLink: false,
    },
  ];
  return retval;
};

export { profileMenuItems as default };
